import React, { useCallback } from 'react';
import { useRouter } from 'next/router';
import * as S from './DesktopFilters.styles';
import { DesktopFilterSelectOptionProps } from './DesktopFilterSelectOption.types';
import { getDesktopFilterSelectOptionHref } from './DesktopFilterSelectOption.helpers';
import { cleanupSeoUrl } from '@/utils/helpers';
import { RadioButton } from '@/components/UI/RadioButton';

export const DesktopFilterSelectOption = ({
  dataTestId,
  label,
  hrefParams,
  isSelected,
  onClick,
  onNavigateHref,
}: DesktopFilterSelectOptionProps) => {
  const router = useRouter();
  const href = getDesktopFilterSelectOptionHref(hrefParams);

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      onClick?.();

      if (onNavigateHref) {
        e.preventDefault();
        onNavigateHref(href);
        return;
      }

      e.preventDefault();
      router.push(href, undefined, { scroll: false });
    },
    [href, onClick, onNavigateHref, router]
  );

  return (
    <S.LinkOption
      key={label}
      dataTestId={dataTestId}
      href={cleanupSeoUrl(href)}
      $isActive={isSelected}
      onClick={handleClick}
    >
      <RadioButton $isActive={isSelected} />
      <S.LinkOptionText>{label}</S.LinkOptionText>
    </S.LinkOption>
  );
};
